import { render, staticRenderFns } from "./DistributorProductTable.vue?vue&type=template&id=f7de37a4"
import script from "./DistributorProductTable.vue?vue&type=script&lang=js"
export * from "./DistributorProductTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports